import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

// Handles resolution suggestion card interactions:
// - "Use as Reply" triggers draft generation via SupportReplyDraftAgent
// - "Dismiss" discards the AIInsight and hides the card
export default class extends Controller {
  static values = {
    insightId: String,
    useUrl: String,
    dismissUrl: String,
    generatingText: String,
    useAsReplyText: String,
  }

  async use() {
    const button = this.element.querySelector('[data-action*="use"]')
    if (button) {
      button.disabled = true
      button.textContent = this.generatingTextValue
    }

    try {
      const response = await post(this.useUrlValue, {
        responseKind: "json",
      })

      if (response.ok) {
        const data = await response.json
        // Populate the reply textarea with the generated draft
        const replyTextarea = document.querySelector(
          '[data-controller*="reply"] textarea, #reply-content, [name*="content"]',
        )
        if (replyTextarea && data.draft) {
          replyTextarea.value = data.draft
          replyTextarea.dispatchEvent(new Event("input", { bubbles: true }))
        }
        // Hide the suggestion card after use
        this.element.classList.add("opacity-50")
      }
    } catch (error) {
      console.error("[ResolutionSuggestion] Use failed:", error)
    } finally {
      if (button) {
        button.disabled = false
        button.textContent = this.useAsReplyTextValue
      }
    }
  }

  async dismiss() {
    try {
      const response = await post(this.dismissUrlValue, {
        responseKind: "json",
      })

      if (response.ok) {
        // Animate out and remove the card
        this.element.style.transition = "opacity 200ms, height 200ms"
        this.element.style.opacity = "0"
        this.element.style.overflow = "hidden"
        setTimeout(() => {
          this.element.style.height = "0"
          this.element.style.padding = "0"
          this.element.style.margin = "0"
          setTimeout(() => this.element.remove(), 200)
        }, 200)
      }
    } catch (error) {
      console.error("[ResolutionSuggestion] Dismiss failed:", error)
    }
  }
}
